
export const budgetpagetext = {
  general: {
    name: "Nom",
    groups: "Périmètre",
    status: "Statut",
    datebegin: "Date de début",
    dateend: "Date de fin",
    code: "Code/clé",
    energy: "Fluide associé",
    totalventilation: "Ventilation totale (%)",
    missingamount: "Reste à allouer (€)",
    amount: "Montant (€)",
    amounttaxes: "Montant défini en",
    associateddocuments: "Fichiers associés",
    description: "Description",
    perimeter: "Périmètre",
    account: "Compte"
  },
  ventilation: {
    name: "Nom",
    bypercentage: "Déterminer le montant en % du budget",
    groups: "Groupe",
    amount: "Montant (€)",
    amountpercentage: "% du budget",
  },
  performance : "Performance"
};
